import React, { useState } from 'react'
import RMPButton from '../rmp/RMPButton'
import { Link } from "react-router-dom"
import { CREATE_RATING_ROUTE } from '../../constants/routes'
import styled from 'styled-components';
import { cherryRed } from '../../constants/colors';
import RatingFeed from '../Rating/ratingfeed';
import ProfPic from '../Rating/profpic';
import { useUser } from '../../helpers/user';

const SORT_OPTIONS = [
    { value: 'recent',    label: 'Most recent' },
    { value: 'oldest',    label: 'Oldest first' },
    { value: 'liked',     label: 'Most liked' },
    { value: 'commented', label: 'Most commented' },
]

const Styles = styled.div`
    max-width: 680px;
    margin: 24px auto;
    padding: 0 16px;
`

const ControlBar = styled.div`
    background: rgba(255,255,255,0.7);
    backdrop-filter: blur(6px);
    border-radius: 14px;
    padding: 12px 16px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.07);
`

const TopRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`

const SortRow = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`

const SortPill = styled.button`
    border: 2px solid ${p => p.active ? cherryRed : '#ddd'};
    background: ${p => p.active ? cherryRed : 'transparent'};
    color: ${p => p.active ? '#fff' : '#555'};
    border-radius: 20px;
    padding: 4px 14px;
    font-size: 0.8rem;
    font-weight: ${p => p.active ? '600' : '400'};
    cursor: pointer;
    transition: all 0.15s;

    &:hover {
        border-color: ${cherryRed};
        color: ${p => p.active ? '#fff' : cherryRed};
    }
`

export default function LandingPage({}) {
    const { user } = useUser()
    const [sort, setSort] = useState('recent')

    return <Styles>
        <ControlBar>
            <TopRow>
                {!!user && <ProfPic username={user.username} height='56px' width='56px'/>}
                <Link to={CREATE_RATING_ROUTE}>
                    <RMPButton>Rate New Pini</RMPButton>
                </Link>
            </TopRow>
            <SortRow>
                {SORT_OPTIONS.map(opt => (
                    <SortPill
                        key={opt.value}
                        active={sort === opt.value}
                        onClick={() => setSort(opt.value)}
                    >
                        {opt.label}
                    </SortPill>
                ))}
            </SortRow>
        </ControlBar>
        <RatingFeed sort={sort}/>
    </Styles>
}